import React from "react";
import NumericFormat from "react-number-format";

interface PointsViewProps {
  points: string | number | null | undefined;
}

const PointsView: React.FC<PointsViewProps> = (props) => {
  return (
    <NumericFormat
      value={props.points}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      displayType="text"
      renderText={(value) =>
        <React.Fragment>{value}</React.Fragment>}
    />
  );
};

export default PointsView;
